var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgQuoteEnd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quotation-mark-svgrepo-com 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0693 33.2533L21.0693 27.246C21.0693 26.4313 21.7481 25.7712 22.5854 25.7712C25.5729 25.7712 27.198 22.7898 27.4233 16.9056L22.5854 16.9056C21.7481 16.9056 21.0693 16.2449 21.0693 15.4304L21.0693 2.74643C21.0693 1.93213 21.7481 1.2719 22.5854 1.2719L35.4842 1.2719C36.3219 1.2719 37 1.93264 37 2.74643L37 15.4305C37 18.2512 36.7081 20.8398 36.1327 23.125C35.5425 25.4682 34.6366 27.5169 33.4408 29.2145C32.2105 30.9592 30.6714 32.3282 28.8662 33.2819C27.0487 34.2415 24.9352 34.7281 22.5849 34.7281C21.7481 34.7281 21.0693 34.068 21.0693 33.2533ZM1.51624 25.7711C0.679311 25.7711 -3.08941e-06 26.4318 -3.16058e-06 27.2459L-3.68575e-06 33.2532C-3.75698e-06 34.0679 0.679203 34.728 1.51624 34.728C3.86558 34.728 5.97941 34.2412 7.79625 33.2818C9.60184 32.3281 11.1417 30.9591 12.3723 29.2144C13.5676 27.5168 14.4735 25.468 15.0638 23.1243C15.6389 20.8383 15.9308 18.2498 15.9308 15.4303L15.9308 2.74633C15.9308 1.93202 15.2518 1.27179 14.4147 1.27179L1.51635 1.27179C0.67942 1.27179 0.000742918 1.93254 0.000742847 2.74633L0.000741738 15.4304C0.000741667 16.2448 0.679311 16.9056 1.51634 16.9056L6.2852 16.9056C6.06336 22.7897 4.46201 25.7711 1.51624 25.7711Z",
    fill: "#6D597A",
    fillOpacity: 0.28
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuoteEnd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quote-end.80669ee0.svg";
export { ForwardRef as ReactComponent };